import { Box, Paper, Typography } from '@mui/material';
import React from 'react';
import QuizProgressOverall from '../Crosspage/QuizProgressOverall';
import { useTranslation } from 'react-i18next';

export default function QuizzeWidget(props) {
    
    const {i18n} = useTranslation()

    const translatedQuizName = props.quiz.name[i18n.language]

    if (!props.progress) {
        return(
            <Paper key={props.quiz.id} sx={{p: 1, ml: {xs: 0, sm: 1}, mr: {xs: 0, sm: 1}, mb: 1, mt: 1, display: "flex", flexDirection: "column", justifyContent: "space-between", alignItems: "center"}}>
                <Box sx={{display: "flex", flexDirection: "column", width: "100%"}}>
                    <Typography>{translatedQuizName}</Typography>
                    <Box sx={{display: "flex", width: "100%"}}>
                        <QuizProgressOverall max={3} n_finished={0}/>
                    </Box>
                </Box>
            </Paper>
        )
    } else {
        return(
            <Paper key={props.quiz.id} sx={{p: 1, ml: {xs: 0, sm: 1}, mr: {xs: 0, sm: 1}, mb: 1, mt: 1, display: "flex", flexDirection: "column", justifyContent: "space-between", alignItems: "center"}}>
                <Box sx={{display: "flex", flexDirection: "column", width: "100%"}}>
                    <Typography>{translatedQuizName}</Typography>
                    <Box>
                        <QuizProgressOverall max={3} n_finished={props.progress.timesFinished}/>
                    </Box>
                </Box>
            </Paper>
        )
    }
}